import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authenticationReducer from '../stores/authentication';
import appReducer from '../stores/app';
import dashboardReducer from '../stores/dashboard';
import modalReducer from '../stores/modal';
import subscriptionReducer from '../stores/subscription';
import signingReducer from '../stores/signing';
import docsReducer from '../stores/docs';
import notificationReducer from '../stores/notification';
import persistReducer from 'redux-persist/es/persistReducer';
import storage from 'redux-persist/lib/storage';
import { rtkAPI } from '../rtk/rtkSetup';
import { setBillingTimezone } from '../util/organizationBillingFormat';
const preloadedState = window.__PRELOADED_STATE__;

const rootPersistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['subscription', 'modal', rtkAPI.reducerPath]
};

const store = configureStore({
  reducer: persistReducer(
    rootPersistConfig,
    combineReducers({
      authentication: authenticationReducer,
      app: appReducer,
      dashboard: dashboardReducer,
      modal: modalReducer,
      subscription: subscriptionReducer,
      signing: signingReducer,
      docs: docsReducer,
      notification: notificationReducer,
      [rtkAPI.reducerPath]: rtkAPI.reducer
    })
  ),
  preloadedState,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(rtkAPI.middleware)
});

// Registered before any component subscribes, so billing dates see the new
// timezone before React re-renders.
store.subscribe(() =>
  setBillingTimezone(store.getState().app?.userMaster?.LocalTimezone)
);

export default store;
